import SingleBanner from '../SingleBanner';
import ChoosifyBanner from '../ChoosifyBanner';

import type { FC, HTMLAttributes, MouseEvent } from 'react';
import type { ProductsBannerData } from '@Promo/typings';

interface BannerSwitchProps extends HTMLAttributes<HTMLDivElement> {
  banner: ProductsBannerData;
  onClickLink?: (e: MouseEvent) => void;
}

const BannerSwitch: FC<BannerSwitchProps> = (props) => {
  const { banner, ...restProps } = props;
  const template = banner.template || 'default';

  switch (template) {
    case 'default': {
      return <SingleBanner banner={banner} {...restProps} />;
    }

    case 'choosify': {
      return <ChoosifyBanner banner={banner} {...restProps} />;
    }
  }
};

export default BannerSwitch;
